import { z } from "zod";
import { pageQuery, trimmed, uuid } from "./common";

/**
 * Обращения в поддержку платформы (ТЗ 03 §8 «Notes & Tickets», `addon.priority_support` — SLA).
 * Писать может любой клиент; с дополнением «Быстрая поддержка» обращение идёт первым в очереди и срок ответа короче.
 */
export const SUPPORT_CATEGORIES = ["question", "problem", "billing", "idea"] as const;
export type SupportCategory = (typeof SUPPORT_CATEGORIES)[number];
/** open — ждёт ответа поддержки; answered — поддержка ответила, ждёт клиента; closed — решено */
export const SUPPORT_STATUSES = ["open", "answered", "closed"] as const;
export type SupportStatus = (typeof SUPPORT_STATUSES)[number];
export type SupportPriority = "normal" | "high";

/** Срок ответа поддержки, часов: обычный и с дополнением «Быстрая поддержка». */
export const SUPPORT_SLA_HOURS: Record<SupportPriority, number> = { normal: 24, high: 2 };

const body = trimmed(1, 5000);
export const supportTicketSchema = z.strictObject({
  subject: trimmed(3, 200),
  category: z.enum(SUPPORT_CATEGORIES),
  body,
});
export type SupportTicketInput = z.input<typeof supportTicketSchema>;
export const supportMessageSchema = z.strictObject({ body });
export type SupportMessageInput = z.input<typeof supportMessageSchema>;
export const supportTicketsQuery = pageQuery.extend({ status: z.enum(SUPPORT_STATUSES).optional() });
export const platformSupportQuery = supportTicketsQuery.extend({ companyId: uuid.optional(), priority: z.enum(["normal", "high"]).optional() });
